module.exports = __webpack_public_path__ + "assets/img/dzh-6.67b68f0f.jpg";